<template>
  <div class="vsd420 flex_1">
    <DashboardLeft></DashboardLeft>
    <Model
      :model-list="modelList"
      :show-view="showView"
      :markeData="markeData"
    ></Model>
    <transition name="shop-transform" mode="out-in">
      <OnlineShop v-if="onlineShop" :onlineShop="onlineShop"></OnlineShop>
    </transition>
    <DashboardRight></DashboardRight>
    <Control
      :onlineShop="onlineShop"
      :choose-controls="chooseControls"
    ></Control>
  </div>
</template>
<script>
import Model from "@/components/devices/VSD420-HighVibration/Model3D"
import DashboardLeft from "@/components/devices/VSD420-HighVibration/dashboard_left/DashboardLeft"
import DashboardRight from "@/components/devices/VSD420-HighVibration/dashboard_right/DashboardRight"
import OnlineShop from "@/components/devices/VSD420-OnlineShop/Index";
import Control from "@/components/devices/Control"
let list = [
  "http://52.83.66.102:5011/public/VSD420/干泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵电机.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵电机.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-振动设备.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵上非驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵上驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵电机上非驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵电机上驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵电机非驱动点.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵非驱动点.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵驱动点.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵上非驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵上驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵电机上非驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵电机上驱动线.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵电机非驱动点.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵电机驱动点.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵非驱动点.glb",
  "http://52.83.66.102:5011/public/VSD420/high/螺杆泵驱动点.glb",
  "http://52.83.66.102:5011/public/VSD420/high/罗茨泵电机驱动点.glb"

  /*  */
  // "http://52.83.66.102:5011/public/VSD420/high/振动设备.glb"
];
import { VSD420_High } from "./data.js";
import _ from "lodash";
export default {
  name: "vsd420-H",
  data() {
    return {
      chooseControls: 3,
      onlineShop: false,
      showView: true,
      modelList: list,
      markeData: VSD420_High,
      timer: null
    };
  },
  computed: {
    VSD420_Hight() {
      return {
        lcbdj_fqd: [
          {
            label: this.$t("Peak acceleration"),
            value: "20.14",
            status: "normal"
          },
          {
            label: this.$t("Speed RMS"),
            value: "1.067",
            status: "normal"
          },
          {
            label: this.$t("Peak envelope"),
            value: "30.25",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "0.5",
            status: "normal"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "50",
            status: "normal"
          }
        ],
        lcbdj_qd: [
          {
            label: this.$t("Peak acceleration"),
            value: "69.64",
            status: "warning"
          },
          {
            label: this.$t("Speed RMS"),
            value: "1.067",
            status: "warning"
          },
          {
            label: this.$t("Peak envelope"),
            value: "30.25",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "0.5",
            status: "warning"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "50",
            status: "warning"
          }
        ],
        lcb_qd: [
          {
            label: this.$t("Peak acceleration"),
            value: "80.53",
            status: "warning"
          },
          {
            label: this.$t("Speed RMS"),
            value: "5.12",
            status: "warning"
          },
          {
            label: this.$t("Peak envelope"),
            value: "90.23",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "0.5",
            status: "warning"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "60",
            status: "warning"
          }
        ],
        lcb_fqd: [
          {
            label: this.$t("Peak acceleration"),
            value: "90.53",
            status: "error"
          },
          {
            label: this.$t("Speed RMS"),
            value: "7.21",
            status: "error"
          },
          {
            label: this.$t("Peak envelope"),
            value: "130.68",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "2.5",
            status: "error"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "45",
            status: "error"
          }
        ],
        lgbdj_fqd: [
          {
            label: this.$t("Peak acceleration"),
            value: "60.64",
            status: "normal"
          },
          {
            label: this.$t("Speed RMS"),
            value: "1.067",
            status: "normal"
          },
          {
            label: this.$t("Peak envelope"),
            value: "30.25",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "0.5",
            status: "normal"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "50",
            status: "normal"
          }
        ],
        lgbdj_qd: [
          {
            label: this.$t("Peak acceleration"),
            value: "20.14 ",
            status: "normal"
          },
          {
            label: this.$t("Speed RMS"),
            value: "1.067",
            status: "normal"
          },
          {
            label: this.$t("Peak envelope"),
            value: "30.25",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "0.5",
            status: "normal"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "50",
            status: "normal"
          }
        ],
        lgb_qd: [
          {
            label: this.$t("Peak acceleration"),
            value: "20.14 ",
            status: "normal"
          },
          {
            label: this.$t("Speed RMS"),
            value: "1.067",
            status: "normal"
          },
          {
            label: this.$t("Peak envelope"),
            value: "30.25",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "0.5",
            status: "normal"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "50",
            status: "normal"
          }
        ],
        lgb_fqd: [
          {
            label: this.$t("Peak acceleration"),
            value: "20.14 ",
            status: "normal"
          },
          {
            label: this.$t("Speed RMS"),
            value: "1.067",
            status: "normal"
          },
          {
            label: this.$t("Peak envelope"),
            value: "30.25",
            status: "normal"
          },
          {
            label: this.$t("Bearing Status"),
            value: "0.5",
            status: "normal"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "50",
            status: "normal"
          }
        ]
      };
    }
  },
  created() {},
  mounted() {
    this.makedata = this.VSD420_Hight;
    window.addEventListener("resize", () => {
      window.location.reload();
    });
    this.timer = setInterval(() => {
      this.markeData = this.changeData();
    }, 2000);
  },
  beforeUnmount() {
    window.removeEventListener("resize", () => {
      window.location.reload();
    });
    if (this.timer) {
      this.timer = null;
    }
  },
  methods: {
    changeData() {
      let copyData = _.cloneDeep(this.VSD420_Hight);
      Object.values(copyData).forEach(obj => {
        obj.forEach(data => {
          if (data.label == this.$t("Peak acceleration")) {
            data.value = this.randoms(
              Number(data.value),
              Number(data.value) + 10
            );
            if (data.value >= 0 && data.value < 70) {
              data.status = "normal";
            }
            if (data.value >= 70 && data.value < 90) {
              data.status = "warning";
            }
            if (data.value >= 90) {
              data.status = "error";
            }
          }
          if (data.label == this.$t("Speed RMS")) {
            data.value = this.randoms(
              Number(data.value),
              Number(data.value) + 1
            );
            if (data.value >= 0 && data.value < 2.5) {
              data.status = "normal";
            }
            if (data.value >= 2.5 && data.statvalueus < 5) {
              data.status = "warning";
            }
            if (data.value >= 5) {
              data.status = "error";
            }
          }
          if (data.label == this.$t("Bearing Status")) {
            data.value = this.randoms(
              Number(data.value),
              Number(data.value) + 1
            );
            if (data.value >= 0.5 && data.value < 1) {
              data.status = "normal";
            }
            if (data.value >= 1 && data.value < 2) {
              data.status = "warning";
            }
            if (data.value >= 3) {
              data.status = "error";
            }
          }
          if (data.label == this.$t("Bearing temperature")) {
            data.value = this.randoms(
              Number(data.value),
              Number(data.value) + 10
            );
            if (data.value >= 50 && data.value < 70) {
              data.status = "normal";
            }
            if (data.value >= 70 && data.value < 80) {
              data.status = "warning";
            }
            if (data.value >= 80) {
              data.status = "error";
            }
          }
        });
      });
      return copyData;
    },
    randoms(min, max) {
      return parseFloat(Math.random() * (max - min) + min).toFixed(1);
    }
  },
  components: {
    Model,
    DashboardLeft,
    DashboardRight,
    OnlineShop,
    Control
  }
};
</script>

<style lang="scss">
@import url("../../../assets/scss/common.scss");

.vsd420 {
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 16px;
}
</style>
